import { Action, createReducer, on } from '@ngrx/store';
import * as fromPaymentsAndInvoicesActions from '../actions';
import { IPayrollCalendarResponse } from '../models/payroll-calendar-response.model';

export const payrollCalendarFeatureKey = 'payrollCalendar';

export interface State {
  loaded: boolean;
  error?: Error | any;
  response: IPayrollCalendarResponse[];
}

export const initialState: State = {
  loaded: false,
  error: undefined,
  response: undefined
};

export const reducer = createReducer(
  initialState,
  on(fromPaymentsAndInvoicesActions.loadPayrollDays, fromPaymentsAndInvoicesActions.savePayrollDays, state => state),
  on(
    fromPaymentsAndInvoicesActions.loadPayrollDaysSuccess,
    (state, action) => ({ ...state, response: action.response, loaded: true })
  ),

  on(fromPaymentsAndInvoicesActions.loadPayrollDaysFailure, fromPaymentsAndInvoicesActions.savePayrollDaysFailure, (state, { error }) => ({
    ...state,
    error
  }))
);

export const selectPayrollDays = (state: State) => state.response;
export const selectPayrollDaysLoaded = (state: State) => state.loaded;
export const selectPayrollDaysError = (state: State) => state.error;
